// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DetailFilePopup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import { Table, Column } from 'share/components/controls/DataGrid/Izenda.Table';
import { TableDefinition, TitlesData } from 'logic/data/Izenda.ImportConstants';
import { join, find } from 'lodash/fp';
import connect from 'share/enhancers/Izenda.Connect';

const TABLE_DEF = TableDefinition.ReportInformation;

@connect()
export default class DetailFilePopup extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    content: PropTypes.object,
    loadAccessRights: PropTypes.array
  };

  /**
   * Render item's data information
   * @param {string} label
   * @param {string} value
   */
  renderDataItem(label: string, value: string) {
    return (
      <div className="izenda-GridLayout-Row">
        <div className="izenda-GridLayout-Col3">{label}</div>
        <div className="izenda-GridLayout-Col9 u_textBreak">{value}</div>
      </div>
    );
  }

  /**
   * Render table data information
   */
  renderDataInformation() {
    const { localization, content } = this.props;
    const { settingLevel, databases, querySources, customViews, calculatedFields } = content;

    return (
      <div>
        <div className="u_textBold u_marginBottom">{localization.getText('IMPORT_DATA_INFORMATION')}</div>
        <div className="u_borderAll u_borderRadius">
          <ScrollBox className="izenda-DataInformation-Container">
            <div className="izenda-GridLayout u_paddingAll">
              {this.renderDataItem(TitlesData['settingLevel'], settingLevel)}
              {this.renderDataItem(TitlesData['databases'], join('; ', databases))}
              {this.renderDataItem(TitlesData['dataSources'], join('; ', querySources))}
              {this.renderDataItem(TitlesData['customViews'], join('; ', customViews))}
              {this.renderDataItem(TitlesData['calculatedFields'], join('; ', calculatedFields))}
            </div>
          </ScrollBox>
        </div>
      </div>
    );
  }

  /**
   * Render accessor roles names with border-box
   * @param {Array} accessorNames
   */
  renderRoles(accessorNames: Array<string>) {
    return accessorNames.map((accessorName, index) => (
      <div key={index} className="Select-value" title={accessorName}>
        <span className="Select-value-label">{accessorName}</span>
      </div>
    ));
  }

  /**
   * Render share column
   * @param {Object} data
   */
  renderShare = (data: any) => {
    return (
      <div className="izenda-GridLayout">
        <div className="izenda-GridLayout-Row">
          <label className="izenda-GridLayout-Col1 u_marginTop">{data.assignedTypeName}</label>
          <div className="u_textBreak Select--multi izenda-GridLayout-Col11">
            {data.accessorNames && this.renderRoles(data.accessorNames)}
          </div>
        </div>
      </div>
    );
  };

  /**
   * Rebder access column
   * @param {Object} data
   */
  renderAccess = (data: any) => {
    const { loadAccessRights } = this.props;
    const accessRightName = find({ id: data.accessRightId }, loadAccessRights);
    const accessName = accessRightName ? accessRightName.name : '';

    return <label>{accessName}</label>;
  };

  /**
   * Render table access rights
   */
  renderAccessRights() {
    const { localization, content: { accessRights } } = this.props;

    return (
      <div>
        <div className="u_textBold u_paddingTopBottom">{localization.getText('COMMON_LABEL_ACCESS_RIGHT')}</div>
        <div className="u_borderAll u_borderRadius">
          <div className="u_clearBoth">
            <Table dataSource={accessRights} sortInfo>
              <Column {...TABLE_DEF['shareWith']} cell={this.renderShare} />
              <Column {...TABLE_DEF['accessRights']} cell={this.renderAccess} />
            </Table>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { localization, title } = this.props;

    return (
      <Popup visible onClosing={this.props.onReject} type="none" autoClose={false} sizeClass="modal-lg">
        <Popup.Header title={title} />
        <Popup.Body>
          {this.renderDataInformation()}
          {this.renderAccessRights()}
        </Popup.Body>
        <Popup.Footer>
          <Popup.ConfirmationButton key="accept" type="accept">
            {localization.getText('COMMON_LABEL_OK')}
          </Popup.ConfirmationButton>
        </Popup.Footer>
      </Popup>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Import/Popup/Izenda.DetailFilePopup.js